import ProductTagList from '@/data/productTag/view/list.vue'

const list = {
  path: '/productTag',
  name: 'productTag-list',
  component: ProductTagList
}

export default [list]
